import { Apis } from "../../../lib/Apis";

export const similarDesingHook = () => {
    const getSimilarDesingData = async (setSimilarDesingData, similarId) => {
        try {
            const respsone = await Apis.getSimilarDesign(similarId);
            setSimilarDesingData(respsone.data.data);
            return respsone.data.data
        } catch (error) {
            console.error(error);
            return error
        }
    }
    const getSimilarDesignExpectSelected = async (setListingData, designId) => {
        try {
            const respsone = await Apis.getSimilarDesignExpectSelected(designId);
            setListingData(respsone.data);
            return respsone.data.data
        } catch (error) {
            console.error(error);
            return error
        }
    }
    const addSimilarDesign = async (data) => {
        try {
            const respsone = await Apis.addSimilarDesign(data);
            return respsone.data
        } catch (error) {
            console.error(error);
        }
    }
    const deleteSimilarDesign = async (id) => {
        try {
            const respsone = await Apis.removeSimilarDesign(id);
            return respsone.data
        } catch (error) {
            console.error(error);
        }
    }

    const updateSimilarDesignPosition = async (id, position) => {
        try {
            const response = await Apis.updateSimilarHouseDesignPosition(id, position);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    return {
        getSimilarDesingData,
        addSimilarDesign,
        deleteSimilarDesign,
        getSimilarDesignExpectSelected,
        updateSimilarDesignPosition,
    }
}
